import { render, staticRenderFns } from "./profileComponent.vue?vue&type=template&id=03d537ba&scoped=true&"
import script from "./profileComponent.vue?vue&type=script&lang=js&"
export * from "./profileComponent.vue?vue&type=script&lang=js&"
import style0 from "./profileComponent.vue?vue&type=style&index=0&id=03d537ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d537ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VSkeletonLoader})
